// Simple encryption key - in a real application, this should be stored securely
const ENCRYPTION_KEY = 'XIecMGNXWdjpoHaOxFRcmB0YjNfTSCZ09qluGptdAnA=';

// Function to encrypt a string
export const encryptId = (id) => {
  try {
    // Convert the ID to a string and add some padding
    const paddedId = String(id).padStart(10, '0');
    
    // Create a simple encryption by shifting characters
    const encrypted = paddedId.split('').map((char, index) => {
      const keyChar = ENCRYPTION_KEY[index % ENCRYPTION_KEY.length];
      const shift = keyChar.charCodeAt(0) % 10;
      const newChar = (parseInt(char) + shift) % 10;
      return newChar.toString();
    }).join('');

    // Convert to base64 for URL safety
    return btoa(encrypted);
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

// Function to decrypt a string
export const decryptId = (encryptedId) => {
  try {
    // Decode from base64
    const decoded = atob(encryptedId);
    
    // Reverse the encryption
    const decrypted = decoded.split('').map((char, index) => {
      const keyChar = ENCRYPTION_KEY[index % ENCRYPTION_KEY.length];
      const shift = keyChar.charCodeAt(0) % 10;
      const newChar = (parseInt(char) - shift + 10) % 10;
      return newChar.toString();
    }).join('');

    // Remove padding and convert back to number
    return parseInt(decrypted.replace(/^0+/, ''));
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}; 